import React from 'react';

// 'onGoToTasks' wurde zu den Props hinzugefügt
const Dashboard = ({ userProfile, tasks, userId, onGoToTasks }) => {
    // Berechnet die Anzahl der offenen Aufgaben für den aktuellen Benutzer.
    const openTaskCount = tasks.filter(task => 
        task.assigneeUids?.includes(userId) && task.status !== 'Erledigt'
    ).length;

    // Berechtigungsinfos für die Anzeige (nur Info, keine Actions)
    const isGF = userProfile?.permissions?.viewAllProjects;
    const projects = userProfile?.allowedProjects || [];

    return (
        <div className="p-4 space-y-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
                <h2 className="text-3xl font-bold text-gray-800 dark:text-white">
                    Willkommen zurück, {userProfile?.firstName || 'Benutzer'}!
                </h2>
                {/* Hier könnten weitere Dashboard-Filter hin */}
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                
                {/* Kachel für offene Aufgaben */}
                <div 
                    onClick={onGoToTasks} // Click-Handler
                    title="Zur Aufgabenübersicht wechseln"
                    className="group p-6 bg-white dark:bg-gray-800 rounded-2xl shadow-lg text-center transform hover:scale-105 transition-all duration-300 cursor-pointer hover:shadow-xl border border-transparent hover:border-blue-500 dark:hover:border-blue-400"
                >
                    <div className="flex justify-center items-center mb-4">
                        <div className="p-4 bg-blue-100 dark:bg-blue-900/40 rounded-full group-hover:bg-blue-200 dark:group-hover:bg-blue-800 transition-colors">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-600 dark:text-blue-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 3h3m-6-3h.01M9 16h.01" />
                            </svg>
                        </div>
                    </div>
                    <h3 className="text-lg font-bold text-gray-700 dark:text-gray-200 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">Meine offenen Aufgaben</h3>
                    <p className="text-5xl font-black text-blue-600 dark:text-blue-400 mt-3">{openTaskCount}</p>
                </div>
                
                {/* Info-Kachel: Mein Status (Optional) */}
                {(isGF || projects.length > 0) && (
                    <div className="p-6 bg-white dark:bg-gray-800 rounded-2xl shadow-lg text-center border border-gray-100 dark:border-gray-700">
                        <div className="flex justify-center items-center mb-4">
                            <div className="p-4 bg-purple-100 dark:bg-purple-900/40 rounded-full">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-purple-600 dark:text-purple-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                        </div>
                        <h3 className="text-lg font-bold text-gray-700 dark:text-gray-200">Zugriffsrechte</h3>
                        <div className="mt-3">
                            {isGF ? (
                                <span className="px-3 py-1 bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200 rounded-full text-sm font-bold">
                                    Geschäftsführung
                                </span>
                            ) : (
                                <div>
                                    <p className="text-xs text-gray-500 mb-1">Zugriff auf:</p>
                                    <div className="flex flex-wrap justify-center gap-1">
                                        {projects.map(p => (
                                            <span key={p} className="px-2 py-1 bg-gray-100 dark:bg-gray-700 rounded text-xs font-medium">
                                                {p}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                
                {/* Weitere Kacheln können hier folgen */}
            </div>
        </div>
    );
};

export default Dashboard;